import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { MarginCalculatorBaseService } from './margin-calculator-base.service';
import { IdentityService } from 'src/app/core/identity.service';
import { Observable } from 'rxjs';

export interface UserCredentials {
    userId: number;
    isNurseContract: boolean;
    isRecruiter: boolean;
    hasPilotPermission: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class MarginCalculatorAuthService extends MarginCalculatorBaseService {
    private _userCredentials: UserCredentials;

    constructor(
        private readonly _http: HttpClient,
        private readonly _identityService: IdentityService
    ) {
        super();
    }

    get userCredentials(): UserCredentials {
        return this._userCredentials;
    }

    getUserCredentials(): Observable<UserCredentials> {
        if (this._identityService.enforceOAuth) {
            return this._http
                .get<UserCredentials>(`${this.coreApiPath}/margin-calculator/user-credential`)
                .pipe(map((response) => (this._userCredentials = response)));
        } else {
            return this._http
                .get<UserCredentials>(`${this.coreApiPath}/margin-calculator/user-credential`, {
                    headers: { Authorization: `Bearer ${this._identityService.current.coreAccessToken}` }
                })
                .pipe(map((response) => (this._userCredentials = response)));
        }
    }
}
